import { Fragment, useMemo } from 'react';
import { pathgen } from 'object-path-generator';
import { TableList, Typography } from 'seagull';
import { utils } from "../../../../../utils";
import { CustomerChargesTable } from "./CustomerChargesTable/CustomerChargesTable";
import styles from "./BulkInvoiceDetails.module.scss";
import { Box } from '@material-ui/core';
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
export const BulkInvoiceDetailsTestIds = pathgen('BulkInvoiceDetailsTestIds');
const columnDefs = [{
  width: 300,
  hAlign: 'start'
}, {
  width: 120,
  hAlign: 'end'
}, {
  width: 120,
  hAlign: 'end'
}, {
  width: 120,
  hAlign: 'end'
}];
const headerItems = [{
  value: 'Client'
}, {
  value: 'Bill Type'
}, {
  value: 'Issue Date'
}, {
  value: 'Total'
}];
export const BulkInvoiceDetails = _ref => {
  let {
    invoices
  } = _ref;
  if (!invoices || invoices.length === 0) {
    return null;
  }
  const tableItems = useMemo(() => invoices.map((invoice, index) => {
    const invoiceId = "invoice-".concat(index);
    const agreementName = invoice.agreementName || 'Untitled agreement';
    return {
      id: invoiceId,
      customerIndex: index,
      invoice,
      cells: [{
        content: /*#__PURE__*/_jsxs(Box, {
          children: [/*#__PURE__*/_jsx(Typography, {
            ellipsis: true,
            variant: "paragraph1",
            weight: "bold",
            "data-testid": BulkInvoiceDetailsTestIds.CustomerRow.CustomerName(index),
            children: invoice.customerName
          }), /*#__PURE__*/_jsx(Typography, {
            ellipsis: true,
            skin: "secondary",
            variant: "paragraph2",
            "data-testid": BulkInvoiceDetailsTestIds.CustomerRow.Agreement(index),
            children: agreementName
          })]
        })
      }, {
        content: invoice.billType === 'BILL_NOW' ? 'Bill now' : 'Bill on date',
        'data-testid': BulkInvoiceDetailsTestIds.CustomerRow.BillType(index)
      }, {
        content: invoice.issueDate,
        'data-testid': BulkInvoiceDetailsTestIds.CustomerRow.IssueDate(index)
      }, {
        content: utils.formatDollarAmount(invoice.total),
        'data-testid': BulkInvoiceDetailsTestIds.CustomerRow.Total(index)
      }],
      'data-testid': BulkInvoiceDetailsTestIds.CustomerRow.Root(index)
    };
  }), [invoices]);
  return /*#__PURE__*/_jsx(Box, {
    className: styles.container,
    "data-testid": BulkInvoiceDetailsTestIds.Root(),
    children: /*#__PURE__*/_jsx(TableList.Provider, {
      columnDefs: columnDefs,
      expandableRows: true,
      expandableRowsVariant: "clickableIconAndRow",
      children: /*#__PURE__*/_jsx(TableList.Structure, {
        className: styles.visibleOverflow,
        header: /*#__PURE__*/_jsx(TableList.Header, {
          items: headerItems
        }),
        content: /*#__PURE__*/_jsx(_Fragment, {
          children: tableItems.map((item, customerIndex) => /*#__PURE__*/_jsx(Fragment, {
            children: /*#__PURE__*/_jsx(TableList.Row, {
              "data-testid": item['data-testid'],
              items: item.cells.map(cell => ({
                value: cell.content,
                ['data-testid']: cell['data-testid']
              })),
              expandedContent: () => /*#__PURE__*/_jsx(CustomerChargesTable, {
                invoice: item.invoice,
                customerIndex: customerIndex
              }),
              expandedContentClassName: styles.visibleOverflow
            })
          }, item.id))
        })
      })
    })
  });
};